<div class="message-carrusel animated fadeIn">
	<div class="carousel-group slider">
		<ng-container *ngFor="let item of elements.payload.options; let i = index">
			<div class="carousel-group-content">
				<div class="carousel-group-content-item image" [ngClass]="{'slick-active': i === 0}" >
					<img [src]="item.image_url " *ngIf="item.image_url != undefined">
				</div>
				<div class="carousel-group-content-item title" *ngIf="item.title != ''">
					{{ item.title }}
				</div>
				<div class="carousel-group-content-item subtitle" *ngIf="item.subtitle != ''">
					{{ item.subtitle }}
				</div>
				<div class="carousel-group-content-item buttons">
					<ng-container *ngFor="let button of item.buttons">
						<button type="button" *ngIf="button.type === 'postback'" class="button" (click)="addMessage(button)">{{ button.text }}</button>
						<button type="button" *ngIf="button.type === 'web_url'" class="button" (click)="openUrl(button.intent)">{{ button.text }}</button>
					</ng-container>
				</div>
			</div>
		</ng-container>
	</div>
</div>